module.exports = __webpack_public_path__ + "static/media/down-arrow.993e3d4b.svg";